module.exports = __webpack_public_path__ + "static/media/buy_req_help_2.5c87e075.png";